import styled, { css } from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
var dark = colors.dark,
  coralXlight = colors.coralXlight;
var family = font.family,
  weight = font.weight,
  size = font.size;
export var Font = css(["color:", ";font-family:", ";font-weight:", ";font-size:", ";"], dark, family.aspira, weight.normal, size.px16);
export var FlexMessage = styled.div.withConfig({
  componentId: "sc-19xd9ia-0"
})(["", " background:", ";margin-bottom:10px;min-height:50px;display:flex;align-items:center;flex-direction:row;align-items:center;"], Font, coralXlight);
FlexMessage.displayName = 'Message';
export var MessageText = styled.p.withConfig({
  componentId: "sc-19xd9ia-1"
})(["margin:0px;"]);
export var MessageTextContainer = styled.div.withConfig({
  componentId: "sc-19xd9ia-2"
})(["padding:5px 10px 5px 10px;"]);
export var IconContainer = styled.div.withConfig({
  componentId: "sc-19xd9ia-3"
})(["width:40px;height:40px;margin:8px 0 0 10px;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/MessageBox/styled.js
// module id = 4656
// module chunks = 11